import { Plaque } from "./Plaque";

/**
 * Wall-mounted "why the token matters" plaque. Sister board to RulesBoard
 * (how to play) and RoadmapBoard (what's next).
 *
 * Source: docs/koth-pumpfun-design.md §§ 2 (Economic loop) and 9 (Pump.fun
 * fee-share wiring). If those sections shift, update FLYWHEEL_LINES below —
 * the plaque is the player-facing pitch, the doc is the source of truth.
 */

interface FlywheelBoardProps {
  position: [number, number, number];
  rotation?: [number, number, number];
}

const FLYWHEEL_LINES: string[] = [
  "The prize pool isn't capped to entry fees.",
  "It grows with the token's trade volume.",
  "",
  "THE LOOP",
  "• Every pump.fun trade pays creator fees.",
  "• The vault PDA is one of those fee recipients.",
  "  A slice of every buy AND every sell flows",
  "  straight into the prize pool — no middleman,",
  "  no custodial wallet, on-chain pull-based.",
  "• Keeper sweeps the vault into the live round",
  "  every 60 seconds.",
  "",
  "WHY HOLDERS PLAY HARDER",
  "• More volume → fatter pot.",
  "• Frequent settlements → more eyes on the chart",
  "  → more trades → fatter pot again.",
  "• Win as king. Win as holder. Same loop.",
  "",
  "WHY PLAYERS TRADE",
  "• Every settlement is an event. Charts get",
  "  watched. Some buy in, some take profit.",
  "  Either way, fees flow into the next round.",
];

export function FlywheelBoard({ position, rotation }: FlywheelBoardProps): JSX.Element {
  return (
    <Plaque
      position={position}
      rotation={rotation}
      width={4.4}
      height={5.0}
      backerColor="#0a1f14"
      title="WHY THE TOKEN"
      titleColor="#7fe6a8"
      titleSize={0.28}
      lines={FLYWHEEL_LINES}
      bodyColor="#e8e8ef"
      bodySize={0.16}
      lineSpacing={1.18}
      align="left"
    />
  );
}
